import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormErrors } from '../../inc/error-form';
// import ReplaceAllContent from '../../config/replace-all';
import { GetText, ReplaceInsText, ReplaceText } from '../../config/helper';
import MyCustomUploadAdapterPlugin from '../../inc/ckImageUploader';
import { FaCircleCheck, FaArrowRight } from 'react-icons/fa6';

const authKey = global.config.kindcode.training[22]+global.config.authBearerKey;
const authKey2 = global.config.kindcode.training[3]+global.config.authBearerKey;

function getCategoryList(type,usedfor) {
    return new Promise((resolve) => {
      var dataText ='{"keyword":"","pageShow":"10","usageFor":"'+usedfor+'","type":"'+type+'"}';
    //   var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly","type":"'+type+'"}';
      var dataSend = JSON.parse(dataText);
      fetch(global.config.urlLink+"/categorylist", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Authorization': authKey2
        }, 
        body : JSON.stringify(dataSend)
      }).then(response => {
        if(response.status === 200) {
          return response.json();
        } else {
          console.log('Something happened wrong');
        }
      }).then(resultJson => {
        if(resultJson.status === "200") {
            console.log("Category");
            console.log(resultJson.values);
            if(resultJson.values.length > 0) {
                var result = resultJson.values.filter(ty => ty.content.categoryType.trim() === type.trim());
                resolve(result);  
            } else {
                resolve([])
            }
          
        } else {
          resolve([])
        }
      });
    });
  }

async function getAllDatas(type,usedfor) {
    const categoryresult = getCategoryList(type,usedfor);

    const [thing1] = await Promise.all([categoryresult]);
    var arrReturnValue = {};
    arrReturnValue.categorylist = thing1;
    return arrReturnValue;
}

export default class DiscussionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: '',
      activePage: '',
      member_id: localStorage.getItem('doc_id'),
      member_email: "",
      content_docid: "",
      source: "discussion",
      thread_id: "",
      thread_title: "",
      thread_description: "",
      thread_category: "",
      thread_status: "",
      thread_type: "",
      thread_category_list: [],
      formErrors: { thread_title: '', thread_description: '', thread_category: '', thread_status: '', thread_type: ''},
      threadtitleValid: false,
      threaddescriptionValid: false,
      threadcategoryValid: false,
      threadstatusValid: false,
      threadtypeValid: false,
      formValid: false,
      input_disabled: true,
      success_msg: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleUserCKEditorInput = (e) => {
    const name = "thread_description";
    const value = e.getData();
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }
  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }
  handleUserSelect = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let threadtitleValid = this.state.threadtitleValid;
    let threaddescriptionValid = this.state.threaddescriptionValid;
    let threadcategoryValid = this.state.threadcategoryValid;
    let threadstatusValid = this.state.threadstatusValid;
    let threadtypeValid = this.state.threadtypeValid;
    
    switch(fieldName) {
        case 'thread_title': 
            threadtitleValid = value.trim().length > 0;
            fieldValidationErrors.thread_title = threadtitleValid ? '' : 'title need to be filled';
            break;
        case 'thread_description': 
            threaddescriptionValid = value.trim().length > 0;
            fieldValidationErrors.thread_description = threaddescriptionValid ? '' : 'description need to be filled';
            break;
        case 'thread_category': 
            threadcategoryValid = value.trim().length > 0;
            fieldValidationErrors.thread_category = threadcategoryValid ? '' : 'category need to be filled';
            break;
        case 'thread_status': 
            threadstatusValid = value.trim().length > 0;
            fieldValidationErrors.thread_status = threadstatusValid ? '' : 'visibility need to be filled';
            break;
        case 'thread_type': 
            threadtypeValid = value.trim().length > 0;
            fieldValidationErrors.thread_type = threadtypeValid ? '' : 'type need to be filled';
            break;
        default:
            break;
    }
    
    this.setState({formErrors: fieldValidationErrors,
                    threadtitleValid: threadtitleValid,
                    threaddescriptionValid: threaddescriptionValid,
                    threadcategoryValid: threadcategoryValid,
                    threadstatusValid: threadstatusValid,
                    threadtypeValid: threadtypeValid
                }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.threadtitleValid && this.state.threaddescriptionValid && this.state.threadcategoryValid && this.state.threadstatusValid && this.state.threadtypeValid });
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.thread_title !== '' && this.state.thread_description !== '' && this.state.thread_category !== '' && this.state.thread_status !== '') {
        document.getElementById('loading-area').style.display = 'block'; 
        var urlFetch, datatext;
        var threadTitle,threadDescription,threadCategory,threadStatus;
        if(this.textInputThreadTitle.value === '') { threadTitle = this.state.thread_title; } else { threadTitle = this.textInputThreadTitle.value; }
        if(this.textInputThreadCategory.value === '') { threadCategory = this.state.thread_category; } else { threadCategory = this.textInputThreadCategory.value; }
        if(this.textInputThreadStatus.value === '') { threadStatus = this.state.thread_status; } else { threadStatus = this.textInputThreadStatus.value; }
        
        // if(this.textInputthreadDescription.value === '') { threadDescription = this.state.thread_description; } else { threadDescription = this.textInputthreadDescription.value; }
        threadDescription = ReplaceInsText(this.state.thread_description);
            
        var urlFetch = global.config.urlLink;
        var datatext='{';
        datatext += '"thread_title":"'+threadTitle+'","thread_description":"'+threadDescription+'","thread_category":'+threadCategory+',"thread_status":"'+threadStatus+'","thread_type":"'+this.state.thread_type+'"';
        if(this.state.action === "edit") {
            datatext +=',"thread_id":"'+this.state.thread_id+'","form_id":"form-edit"';
            urlFetch +='/threadedit';
        } else {
            datatext +=',"form_id":"form-add"';
            urlFetch +='/threadadd';
        }
        datatext += '}'

        console.log(datatext);
        var data = JSON.parse(datatext);
        console.log(data)
        fetch(urlFetch, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) 
                return res.json() 
        }).then( resJson => {
            if(resJson.status === '200') {
                var docId = resJson.values;
                this.setState({ 
                    thread_id: docId,
                    success_msg: true
                  });
                // window.location.href=global.config.urlCms+"/"+this.state.activelink;
                // window.location.href=global.ctconfig.urlHost+'/cteditdetailtutor/'+docId;
            } else {
                console.log('Something happened wrong');
            }

            document.getElementById('loading-area').style.display = 'none'; 
        }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
        });
    
    } else {
        console.log("aaa")
        var arrfieldName = ['thread_title','thread_description','thread_category','thread_status'];
        var arrvalue = [this.textInputThreadTitle.value,this.state.thread_description,this.textInputThreadCategory.value,this.textInputThreadStatus.value];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
  }

  componentDidMount() {
    var content = this.props.value;
    console.log("form content")
    console.log(content);
    var data = {}; 
    if(content.data !== undefined) { data = content.data; }
    var promoType = global.config.specialCategory.filter(ty => ty.link.trim() === content.currpage.trim());
    var promoTypeResult = promoType.length > 0? promoType[0].value : '';
    
    getAllDatas(promoTypeResult,"discussion").then((response) => {
        console.log("res");
        console.log(response)

        this.setState({
            action: data.id !== undefined? 'edit' : 'add',
            activePage: content.currpage,
            thread_category_list: response.categorylist,
            thread_id: data.id !== undefined? data.id : '',
            thread_title: data.threadTitle !== undefined? data.threadTitle : '',
            thread_description: data.threadDescription !== undefined? ReplaceText(data.threadDescription) : '',
            thread_category: data.threadCategoryId !== undefined? '{"id":"'+data.threadCategoryId+'","name":"'+data.threadCategoryName.trim()+'"}' : '',
            thread_status: data.threadStatus !== undefined? data.threadStatus : '',
            thread_type: data.threadType !== undefined? data.threadType : promoTypeResult,
            formErrors: { thread_title: '', thread_description: '', thread_category: '', thread_status: '', thread_type: ''},
            input_disabled: false
        });
    });
  }

  render() {
    return (
        <div className="container mb-4">
          <div id="thread-form">
             {
                this.state.success_msg === true ? (
                    <div className="p-4 mb-5  w-100 d-flex justify-content-center"> 
                        <div className="row">
                          <div className="col-lg-2 d-flex justify-content-center">
                            <FaCircleCheck color="green" fontSize="80px" className="mt-2"/>
                          </div>
                          <div className="col-lg-10">
                            <div  className="mt-1 ms-2 fs-3">{GetText()? "Berhasil dikirim" : "Success submitted"}</div>
                            <div  className="mt-2 ms-2 fs-6">{GetText()? "Terima kasih, Anda telah berhasil membuat sebuah topik diskusi." : "Thank you, You've been successfully create a topic for discussion."} </div>
                            <div  className="mt-4 ms-2 fs-6">
                                <span className="link-more" onClick={() => window.location.href=global.config.urlHost+"/"+this.state.activePage+"/discussion"}>{GetText() ? "Lihat Lainnya" : "View More"} <FaArrowRight/></span>
                            </div>
                          </div>
                        </div>
                  </div>  
                ) : (
                <>
                <div className="mt-1">
                    <p className='fs-6'>{GetText() ? "Buat sebuah topik yang menjadi pertanyaan Anda dan Anda membutuhkan diskusi untuk bertukar pikiran" : "Create a topic that became your question and you need a discussion to exchange ideas."}</p>
                </div>
                
                <div className="mt-4">
                    <div >
                    <form onSubmit={this.handleSubmit}>
                        <div className="mt-3">
                            <label htmlFor="thread_title">{GetText()? "Judul" : "Title"}</label>
                            <div className="mt-1">
                                <input type="text" className="form-control" name="thread_title"
                                    placeholder={GetText()? "masukkan judul topik anda" : "input your thread title"}
                                    value={this.state.thread_title}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputThreadTitle = input}
                                    disabled={this.state.input_disabled}
                                    autoFocus
                                    />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.thread_title}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="thread_description">{GetText()? "Keterangan " : "Description"}</label>
                            <div className="discussion-editor">
                                <CKEditor
                                    editor  = { ClassicEditor }
                                    name    = "thread_description"
                                    data    = {this.state.thread_description}
                                    config  = {{
                                      extraPlugins:[MyCustomUploadAdapterPlugin], 
                                      state: this.state, 
                                      key:authKey
                                    }}
                                    onReady = { editor => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log( 'Editor is ready to use!', editor );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                    onChange={ ( event, editor ) => {
                                        this.handleUserCKEditorInput(editor);
                                        const data = editor.getData();
                                        
                                        //this.textInputContentLongDesc = data;
                                        console.log( { event, editor, data } );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                    onBlur={ ( event, editor ) => {
                                        console.log( 'Blur.', editor );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                    onFocus={ ( event, editor ) => {
                                        console.log( 'Focus.', editor );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.thread_description}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="thread_category">{GetText()? "Kategori" : "Category"}</label>
                            <div className="mt-1">
                                <select name="thread_category" className="form-control" 
                                            value={this.state.thread_category} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputThreadCategory = input}
                                            disabled={this.state.input_disabled}
                                        >
                                        <option value="" key="C0">-- please select --</option>
                                        {
                                            this.state.thread_category_list.length > 0 && (
                                                this.state.thread_category_list.map((category_item, c) => {
                                                    var opt_value = '{"id":"'+category_item.docid+'","name":"'+category_item.content.categoryName+'"}';
                                                    return(<option value={opt_value} key={"C"+c}>{category_item.content.categoryName}</option>)
                                                })
                                            )
                                        }
                                        {/* {selcategoryList} */}
                                </select>
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.thread_category}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="thread_status">{GetText()? "Visibilitas" : "Visibility"}</label>
                            <div className="mt-1">
                                <select name="thread_status" className="form-control" 
                                            value={this.state.thread_status} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputThreadStatus = input}
                                            disabled={this.state.input_disabled}
                                        >
                                        <option value="" key="S0">-- please select --</option>
                                        <option value={global.config.threadStatus[0]} key="S1">{global.config.threadStatus[0]}</option>
                                        <option value={global.config.threadStatus[1]} key="S2">{global.config.threadStatus[1]}</option>
                                        {/* {selstatusList} */}
                                </select>
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.thread_status}/>  }</div>
                            </div>
                        </div>
                        
                    
                        <div className="mt-4 mb-3">
                            <Button variant="primary" id="submit" type="submit" style={{ width: "100%", marginTop: "20px" }}>Submit</Button>
                        </div>
                    </form>
                    </div>
                </div>
                </>
                )
              }
                   
          </div>
          <div id="loading-area" className="d-none loading"></div> 
        </div>
    );
  }
}
